import { flushSync } from "react-dom";

export function mask(formatter: (value: string) => string) {
  return (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    const { value, selectionStart, selectionEnd } = input;
    const newValue = formatter(value);
    const diff = newValue.length - value.length;
    flushSync(() => void (input.value = newValue));
    input.setSelectionRange(selectionStart! + diff, selectionEnd! + diff);
  };
}
